// import Revenue from '../../ui/revenue/revenue';

const ViewMerchantDashboard = props => {
  return (
    <p>Revenue</p>
  );
};

export default ViewMerchantDashboard;